import SEOHead from '@/components/common/SEOHead';
import HomeExperience from '@/components/home/HomeExperience';
import { localBusinessSchema, organizationSchema } from '@/lib/seo/structuredData';

const Index = () => (
  <>
    <SEOHead
      title="Nashville 3D Scanning & Matterport Virtual Tours | TourMy.co"
      description="Professional 3D scanning and Matterport virtual tours in Nashville, TN. Construction documentation, real estate tours, and insurance documentation."
      canonicalPath="/"
      keywords="Nashville 3D scanning, Matterport Nashville, virtual tours Nashville TN, construction documentation Nashville"
      structuredData={[localBusinessSchema, organizationSchema]}
    />
    <HomeExperience />
  </>
);

export default Index;
